import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=3ba0cb11&"
import script from "./TabInfo.vue?vue&type=script&lang=js&"
export * from "./TabInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports